import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import * as React from 'react';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import loc from 'owa-localize';
import { moreAppsTitle } from 'owa-left-rail-utils/lib/AppDrawerButton.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { AppDrawer } from 'owa-left-rail';
import { observer } from 'mobx-react-lite';

let styles = require('./LeftRailItem.scss');

export default observer(function AppDrawerButton() {
    const divRef = React.useRef<HTMLDivElement>();
    const [isCalloutVisible, setIsCalloutVisible] = React.useState(false);

    const itemAriaProps: AriaProperties = {
        role: AriaRoles.menuitem,
        label: loc(moreAppsTitle),
    };

    const toggleIsCalloutVisible = React.useCallback(() => setIsCalloutVisible(!isCalloutVisible), [
        isCalloutVisible,
    ]);

    return (
        <div ref={divRef}>
            <CommandBarButton
                styles={{
                    root: styles.appDrawerButton,
                    menuIcon: styles.menuIcon,
                }}
                menuIconProps={{
                    iconName: ControlIcons.More,
                }}
                onClick={toggleIsCalloutVisible}
                title={loc(moreAppsTitle)}
                {...generateDomPropertiesForAria(itemAriaProps)}
            />
            <AppDrawer
                target={divRef}
                hidden={!isCalloutVisible}
                onDismiss={toggleIsCalloutVisible}></AppDrawer>
        </div>
    );
});
